import { ICheckboxesTreeItem } from "../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree/stores/checkboxes-tree-store";
import { IOption } from "../../components/inputs/select-dropdown/select-dropdown";
import { FEATURES } from "../../models/Plan";
import { AUTO_PROCESS_TRIGGER, AUTO_PROCESS_VALIDATED_QUALIFIER, RETURN_LABEL_FEE_PAYMENT } from "../../models/User";
import { RESOLUTION_ID, RESOLUTION_TYPE } from "../resolutions/constants";
import { DISPLAY_FEE_OPTION, FEE_TYPE, IPolicyFee } from "./policy-types";

export enum PROCESS_TYPE {
    MANUAL = 0,
    AUTOMATIC = 1,
}

export function processTypeOptionsList() {
    return [
        { value: PROCESS_TYPE.MANUAL, label: 'Manual' },
        { value: PROCESS_TYPE.AUTOMATIC, label: 'Automatic' },
    ];
}

/** TODO: when translating policy rules page, replace this const with getCaptureTriggerTypesOptions() from User.ts */
export function autoProcessTriggerOptionsList(): IOption[] {
    return [
        { value: AUTO_PROCESS_TRIGGER.RMA_APPROVED, label: 'RMA is approved' },
        { value: AUTO_PROCESS_TRIGGER.SHIPMENT_SHIPPED, label: 'Shipment is in-transit' },
        { value: AUTO_PROCESS_TRIGGER.SHIPMENT_RECEIVED, label: 'Shipment has been received' },
        { value: AUTO_PROCESS_TRIGGER.ITEMS_VALIDATED, label: 'Items have been validated' },
    ];
}

/** TODO: when translating policy rules page, replace this const with getValidatedQualifierOptions() from User.ts */
export function autoProcessValidatedQualifierOptionsList() {
    return [
        { value: AUTO_PROCESS_VALIDATED_QUALIFIER.EXECUTE_WHEN_ALL_RETURNED, label: 'Returned' },
        { value: AUTO_PROCESS_VALIDATED_QUALIFIER.EXECUTE_WHEN_ALL_RESTOCKABLE, label: 'Returned + Restockable' },
    ];
}

export enum AUTO_MARK_DONE_TRIGGER {
    OTHER_AUTOMATIONS = 'OTHER_AUTOMATIONS',
    FULL_VALIDATION = 'FULL_VALIDATION',
    PARTIAL_VALIDATION = 'PARTIAL_VALIDATION',
    FULL_AMOUNT_REFUND_PAYMENT = 'FULL_AMOUNT_REFUND_PAYMENT',
    EXCHANGE_RELEASED = 'EXCHANGE_RELEASED',
}

export const AUTO_MARK_DONE_TRIGGER_OPTIONS_TREE: ICheckboxesTreeItem[] = [
    { value: AUTO_MARK_DONE_TRIGGER.OTHER_AUTOMATIONS, label: 'Other automations' },
    { value: AUTO_MARK_DONE_TRIGGER.FULL_VALIDATION, label: 'Full validation' },
    { value: AUTO_MARK_DONE_TRIGGER.PARTIAL_VALIDATION, label: 'Partial validation' },
    { value: AUTO_MARK_DONE_TRIGGER.FULL_AMOUNT_REFUND_PAYMENT, label: 'Full amount refund/payment' },
    { value: AUTO_MARK_DONE_TRIGGER.EXCHANGE_RELEASED, label: 'Exchange released' },
];

export enum AUTO_PROCESS_EXECUTE {
    SINCE_TRIGGERED = 'since',
    IMMEDIATELY = 'immediately',
}

export function autoProcessExecuteOptionsList() {
    return [
        { value: AUTO_PROCESS_EXECUTE.IMMEDIATELY, label: 'Immediately' },
        { value: AUTO_PROCESS_EXECUTE.SINCE_TRIGGERED, label: 'After...' },
    ];
}

export const DEFAULT_AUTO_MARK_DONE_SINCE_VALUE = 1;

export enum SINCE_UNIT {
    HOURS = 'hours',
    DAYS = 'days',
}

export const getAutoProcessSinceValueOptions = (autoRefundUnits: SINCE_UNIT | null | undefined) => {
    const max = autoRefundUnits === SINCE_UNIT.DAYS ? 14 : 24;
    
    const options = [] as IOption[];
    for (let i = 1; i <= max; i++) {
        options.push({
            value: i,
            label: i,
        });
    }
    
    return options;
}

export function sinceUnitOptionsList() {
    return [
        { value: SINCE_UNIT.HOURS, label: 'Hours' },
        { value: SINCE_UNIT.DAYS, label: 'Days' },
    ];
}


export enum AUTO_MARK_DONE {
    MANUALLY = 0,
    AUTOMATICALLY = 1,
}

export function autoMarkAsDoneOptionsList() {
    return [
        { value: AUTO_MARK_DONE.MANUALLY, label: 'Manual' },
        { value: AUTO_MARK_DONE.AUTOMATICALLY, label: 'Automatic' },
    ];
}


export enum APPROVAL_PROCESS {
    MANUAL = 0,
    AUTO = 1,
}

export function approvalProcessOptionsList() {
    return [
        { value: APPROVAL_PROCESS.MANUAL, label: 'Manual' },
        { value: APPROVAL_PROCESS.AUTO, label: 'Automatic' },
    ];
}

export const CHARGE_OPTIONS = [
    {
        label: 'Free',
        value: 0
    },
    {
        label: 'Charge fee',
        value: 1
    }
];

export const FEE_PAYMENT_OPTIONS = [
    {
        label: 'Always apply a separate charge for return label fees',
        value: RETURN_LABEL_FEE_PAYMENT.ALWAYS_CHARGE,
    },
    {
        label: 'Deduct return label fees from refunds',
        value: RETURN_LABEL_FEE_PAYMENT.DEDUCT_FROM_REFUNDS,
    }
];

export const TAX_OPTIONS = [
    {
        label: 'Charge tax',
        value: 1
    },
    {
        label: 'Don\'t charge tax',
        value: 0
    }
];

export const FEE_TYPE_NON_EDITABLE = [
    FEE_TYPE.CANCELLATION_FEE,
    FEE_TYPE.RESTOCKING_FEE,
    FEE_TYPE.RETURN_FEE
];

export const RESOLUTION_TYPES_SUPPORTING_GIFT_RETURNS_ELIGIBILITY = [
    RESOLUTION_TYPE.Credits, 
    RESOLUTION_TYPE.GiftCard
]

export enum APPLY_ON {
    ALL = 1,
    ALL_EXCEPT_GIFTS = 0,
    GIFTS_ONLY = 2,
}

export function applyOnOptionsList() {
    return [
        { value: APPLY_ON.ALL, label: 'Orders and gifts' },
        { value: APPLY_ON.ALL_EXCEPT_GIFTS, label: 'Orders only' },
        { value: APPLY_ON.GIFTS_ONLY, label: 'Gifts only' },
    ];
}

export enum REFUND_POLICIES_NOTE_TYPE {
    SET_DISPLAY_AS_DISABLED = 'SET_DISPLAY_AS_DISABLED',
    CREATE_REFUND_TO_PAYMENT_METHOD = 'CREATE_REFUND_TO_PAYMENT_METHOD',
}

export enum FEE_STORE_LEVEL {
    CANCEL = 'CANCEL',
    RESTOCK = 'RESTOCK',
    RETURN = 'RETURN',
    SHIPPING_LABEL = 'SHIPPING_LABEL',
}

export const POLICY_FEES_DEFAULS_BY_FEE_STORE_LEVEL= {
    [FEE_STORE_LEVEL.RESTOCK]: {
        fee_type: FEE_TYPE.RESTOCKING_FEE,
        is_charged: false,
    } as IPolicyFee,
    [FEE_STORE_LEVEL.RETURN]: {
        fee_type: FEE_TYPE.RETURN_FEE,
        is_charged: false,
    } as IPolicyFee,
    [FEE_STORE_LEVEL.CANCEL]: {
        fee_type: FEE_TYPE.CANCELLATION_FEE,
        is_charged: false,
    } as IPolicyFee,
    [FEE_STORE_LEVEL.SHIPPING_LABEL]: {
        fee_type: null,
        is_charged: false
    } as IPolicyFee,
};


export const FEATURES_RESOLUTIONS_IDS_MAP: {[key: number]: FEATURES} = {
    [RESOLUTION_ID.PRODUCT_EXCHANGE]: FEATURES.PRODUCT_EXCHANGE,
    [RESOLUTION_ID.CANCEL_ORDER]: FEATURES.CANCEL_ORDER,
    [RESOLUTION_ID.SHIP_LATER]: FEATURES.RETURN_SCORE_RESOLUTION,
    [RESOLUTION_ID.KEEP]: FEATURES.RETURN_SCORE_RESOLUTION,
    [RESOLUTION_ID.DONATE]: FEATURES.RETURN_SCORE_RESOLUTION,
}

export enum CHARGE_FEES {
    DO_NOT_CHARGE_FEE = 0,
    CHARGE_FEE = 1,
    WAIVE_FEES = 2,
};

export const DISPLAY_FEE_OPTION_MAP: Record<DISPLAY_FEE_OPTION, { value: DISPLAY_FEE_OPTION; label: string; }> = {
    [DISPLAY_FEE_OPTION.FREE]: {value: DISPLAY_FEE_OPTION.FREE, label: 'Free'},
    [DISPLAY_FEE_OPTION.INCLUDE_ZERO_FREE]: {value: DISPLAY_FEE_OPTION.INCLUDE_ZERO_FREE, label: 'Includes $0 Fees'},
    [DISPLAY_FEE_OPTION.DO_NOT_MENTION_FEES]: {value: DISPLAY_FEE_OPTION.DO_NOT_MENTION_FEES, label: 'Don’t mention fees'},
};

export const FEE_OPTION_MAP: Record<CHARGE_FEES, { value: CHARGE_FEES; label: string; }> = {
    [CHARGE_FEES.CHARGE_FEE]: {value: CHARGE_FEES.CHARGE_FEE, label: 'Charge additional fees for this policy rule'},
    [CHARGE_FEES.DO_NOT_CHARGE_FEE]: {value: CHARGE_FEES.DO_NOT_CHARGE_FEE, label: 'Do not charge additional fees for this policy rule'},
    [CHARGE_FEES.WAIVE_FEES]: {value: CHARGE_FEES.WAIVE_FEES, label: 'Waive all fees in the RMA'},
};

export const getFeeOptionMap = (): IOption[] => {
    return Object.values(FEE_OPTION_MAP);
};

export const getDisplayFeeOptionMap = (chargeFees: CHARGE_FEES): IOption[] => {
    const isWaiveAllFeesSelected = chargeFees === CHARGE_FEES.WAIVE_FEES;
    
    return Object.values(DISPLAY_FEE_OPTION_MAP).filter(option => {
        // if is not CHARGE_FEES.WAIVE_FEES selected, then filter out DISPLAY_FEE_OPTION.DO_NOT_MENTION_FEES option
        if (!isWaiveAllFeesSelected && option.value === DISPLAY_FEE_OPTION.DO_NOT_MENTION_FEES) {
            return false;
        }
        return true;
    });
};

export enum USED_FOR_OPTIONS {
    USED_FOR_PORTAL = 'USED_FOR_PORTAL',
    USED_FOR_CRMA_ONLINE_USERS = 'USED_FOR_CRMA_ONLINE_USERS',
    USED_FOR_CRMA_PHYSICAL_STORE_USERS = 'USED_FOR_CRMA_PHYSICAL_STORE_USERS',
    USED_FOR_CRMA_VIA_RETURNGO_API = 'USED_FOR_CRMA_VIA_RETURNGO_API',
}
